import GenericAjaxService from './GenericAjaxService';
import {publicAPI} from './api';

export default class ContactUsService extends GenericAjaxService {

    static submitComment(data) {
        return super.postAPI(publicAPI, `contactus`, data);
    }
}
